import PropTypes from 'prop-types';

export default PropTypes.shape({
  uuids: PropTypes.string.isRequired,
  type: PropTypes.number.isRequired,

  created: PropTypes.number.isRequired,
  expires: PropTypes.number,

  endpointsCompleted: PropTypes.bool,
  completed: PropTypes.bool,
});
